import { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { isInDevelopment } from "../../config";
import Options from "../../data/options";
import { getDateObject, getDateObjectLocal } from "../../helpers/Date";
import KlausurSchema from "../../newForms2/klausuren/KlausurSchema";
import DeveloperButton from "../DevloperButton";
import SchuelerMain from "../Schueler/SchuelerMain";
import WordDocumentReact from "../wordDocuments/wordDocuments";
import KlausurSaveButton from "./KlausurSaveButton";
import Auth from "../../helpers/auth";


const KlausurDetails = ({ setView }) => {

  const currentUser = useSelector((st) => st.currentUser);
  const currentKlausur = useSelector((st) => st.currentKlausur);
  const companies = useSelector((st) => st.companies);
  const textbausteine = useSelector((st) => st.textbausteine);
  const schuelerList = useSelector((st) => st.schueler);
  const schema = new KlausurSchema(companies, currentUser);
  const klausurFields = schema.fields;
  const displayedfields = schema.getFields(currentKlausur);
  const displayedKeys = Object.keys(displayedfields);
  const klausur = {};
  displayedKeys.forEach((k) => (klausur[k] = currentKlausur[k]));

  klausur.companyId =
    companies.find((c) => c.id === parseInt(currentKlausur.companyId))?.name ||
    "Unbekannt";
  klausur.date = getDateObject(klausur.date).short;

  const { createdAt, createdBy, updatedAt, updatedBy, id } = currentKlausur;
  const updatedString = updatedAt
    ? ` (Letzte Aktualisierung: ${getDateObjectLocal(updatedAt).dateTime})`
    : "";
  const idString = `, id: ${id}`;

  const handlePrintAll = async (e) => {
    e.preventDefault();
    const x = await WordDocumentReact.createAllGutachten(
      currentUser,
      currentKlausur,
      schuelerList,
      textbausteine,
      companies,
      
    );
  };
  const handleSummary = async (e) => {
    e.preventDefault();
    const x = await WordDocumentReact.createSummary(
      currentUser,
      currentKlausur,
      schuelerList,
      companies,

    );
  };

  const schule = companies.find(
    (c) => c.id === parseInt(currentKlausur.companyId)
  )?.name;



  console.log({currentKlausur, schuelerList})
  return (
    <div
      className="p-3"
      style={{ border: "1px solid grey", borderRadius: "5px" }}
    >
      <h4>{schule}</h4>
      <h5>{`Gutachter: ${currentUser.firstName} ${currentUser.lastName}`}</h5>
      <h5>{`Klausur: ${getDateObject(currentKlausur.date).long}`}</h5>
      <p>
        {`erstellt am ${
          getDateObjectLocal(createdAt).dateTime
        }${updatedString}`}
        {Auth.isDeveloper(currentUser.userStatus) ? <small>{idString}</small>:null}
      </p>
      <div style={{ columnCount: 3 }}>
        <Table>
          <tbody>
            {Object.entries(klausur).map(([k, v]) => {
              return (
                <tr key={k}>
                  <td>{klausurFields[k]?.label || k}</td>
                  <td>{Options.getValue(k, v) || v}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      <Row className="mt-3">
        <Col>
          <button
            className="btn btn-outline-dark"
            onClick={() => setView("formEdit")}
          >
            Klausur bearbeiten
          </button>
        </Col>{" "}
        <Col>
          <KlausurSaveButton />
        </Col>
        <Col>
          <button className="btn btn-outline-dark" onClick={handlePrintAll}>
            Alle Gutachten exportieren
          </button>
        </Col>
        <Col>
          <button className="btn btn-outline-dark" onClick={handleSummary}>
            Zusammenfassung
          </button>
        </Col>
        {currentUser.userStatus === "developer" && isInDevelopment && (
          <DeveloperButton />
        )}
      </Row>
      <SchuelerMain />
    </div>
  );
};
export default KlausurDetails;
